import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var WatchSquare = function WatchSquare(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "M11.35 9.3V12l1.35 1.35"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "M5.5 9.03c0-1.008 0-1.5121.1962-1.8972a1.8 1.8 0 0 1 .7866-.7866C6.8678 6.15 7.372 6.15 8.38 6.15h5.94c1.0081 0 1.5121 0 1.8972.1962a1.8 1.8 0 0 1 .7866.7866c.1962.385.1962.8891.1962 1.8972v5.94c0 1.0081 0 1.5121-.1962 1.8972a1.8 1.8 0 0 1-.7866.7866c-.3851.1962-.8891.1962-1.8972.1962H8.38c-1.008 0-1.5121 0-1.8972-.1962a1.8 1.8 0 0 1-.7866-.7866C5.5 16.4821 5.5 15.9781 5.5 14.97V9.03Z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m15.85 17.85-.3032 1.0612c-.2139.7487-.3209 1.1231-.5393 1.401a1.7998 1.7998 0 0 1-.7347.5542C13.9457 21 13.5563 21 12.7776 21H9.9224c-.7787 0-1.168 0-1.4953-.1336a1.8002 1.8002 0 0 1-.7346-.5542c-.2184-.2779-.3254-.6523-.5393-1.401L6.85 17.85m9-11.7-.3032-1.0612c-.2139-.7487-.3209-1.1231-.5393-1.401a1.7995 1.7995 0 0 0-.7347-.5542C13.9457 3 13.5563 3 12.7776 3H9.9224c-.7787 0-1.168 0-1.4953.1336a1.8 1.8 0 0 0-.7346.5542c-.2184.2779-.3254.6523-.5393 1.401L6.85 6.15m4.5 3.15V12l1.35 1.35m-4.32 4.5h5.94c1.0081 0 1.5121 0 1.8972-.1962a1.8 1.8 0 0 0 .7866-.7866c.1962-.3851.1962-.8891.1962-1.8972V9.03c0-1.008 0-1.5121-.1962-1.8972a1.8 1.8 0 0 0-.7866-.7866C15.8321 6.15 15.3281 6.15 14.32 6.15H8.38c-1.008 0-1.5121 0-1.8972.1962a1.8 1.8 0 0 0-.7866.7866C5.5 7.5178 5.5 8.022 5.5 9.03v5.94c0 1.0081 0 1.5121.1962 1.8972a1.8 1.8 0 0 0 .7866.7866c.385.1962.8891.1962 1.8972.1962Z"
    })]
  }));
};
export default WatchSquare;